import axios from "axios";
import { atom, createStore } from "jotai";
import { loadable, atomWithStorage } from "jotai/utils";
import { LoginStepAtomT } from "src/types/authTypes";
import { refreshAccessKey } from "src/api/authApi";
import { validateUserLogin } from "src/util/auth.util";

const isLoginAtom = atom(validateUserLogin());
const loginStepAtom = atom<LoginStepAtomT>("phoneNumber");
const userPhoneAtom = atom("");
const store = createStore();

export { isLoginAtom, loginStepAtom, userPhoneAtom, store };
